<template>
  <main class="main">
    <div class="grid-container">
      <div class="action action--page">
        <h1 class="u-no-margin">{{ $t("kolonne.title")}}</h1>
      </div>
    </div>
    <div class="grid-container">
      <div class="grid-x align-center">
        <div class="cell small-auto medium-9 large-5">
          <v-action-buttons :items="getActionButtons" @actionClicked="onClickActionButton" />

          <div class="dialog" :class="{ 'active' : showCreateUpdateDialog }">
            <div class="dialog--content">
              <h3>{{ createUpdateDialogTitle }}</h3>

              <div class="form-group">
                <label>{{ $t("kolonne.number") }}</label>
                <input type="text" name="number" v-model="object.number" />
              </div>

              <p class="text-center">
                <button class="button" @click="onSaveKolonne()">{{ $t('save') }}</button>
                <button class="button gray" @click="onCloseCreateUpdateDialog()">{{ $t('cancel') }}</button>
              </p>

              <button class="close-button" v-on:click.prevent="onCloseCreateUpdateDialog()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>

          <v-form-message
            type="success"
            id="form-success"
            :message="objectSuccess"
            :autoCloseTimeout="0"
            @onClickAction="onClickSuccessDialogAction"
          />

          <v-form-message
            type="default"
            :message="removeConfirm"
            :autoCloseTimeout="0"
            :showActionButtons="true"
            @onClickAction="onClickDeleteDialogAction"
          />

          <div class="box u-extra-large-padding--bottom u-extra-medium-padding--top">
            <div class="table-wrapper loading-wrapper" :class="{ 'is-loading' : tableLoading }">
              <table class="table table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">{{ $t("kolonne.number") }}</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <draggable v-model="tableItems" tag="tbody" @end="onReorderKolonneTableItems">
                  <tr v-for="row in tableItems" :key="row.id" class="draggable">
                    <td>{{ row.number }}</td>
                    <td style="width: 46px;">
                      <a
                        @click.prevent="onOpenCreateUpdateDialog(row.id, row.number)"
                        class="button button--action button--action--edit button--small"
                      >{{ $t('update') }}</a>
                    </td>
                    <td style="width: 46px;">
                      <a
                        @click.prevent="onOpenDeleteDialog(row.id, row.number)"
                        class="button button--action button--action--delete button--small"
                      >{{ $t('delete') }}</a>
                    </td>
                  </tr>
                </draggable>
              </table>
              <div class="loading-message" v-if="tableLoading">{{ $t('results_loading') }}</div>
            </div>
          </div>
          <!-- .box-->
        </div>
        <!-- .cell-->
      </div>
      <!-- .grid-x-->
    </div>
    <!-- .grid-container -->
  </main>
</template>
<script>
import FormMessage from "../partials/Forms/FormMessage";
import ActionButtons from "./../partials/Foundation/ActionButtons";
import draggable from "vuedraggable";

export default {
  name: "Kolonne",

  data: function() {
    return {
      tableLoading: true,
      tableItems: [],
      showCreateUpdateDialog: false,
      createUpdateDialogTitle: "",
      removeConfirm: null,
      objectSuccess: "",
      objectError: null,
      object: {
        id: 0,
        number: ""
      }
    };
  },

  components: {
    vFormMessage: FormMessage,
    vActionButtons: ActionButtons,
    draggable
  },

  created: function() {
    this.getKolonneItems();
  },

  computed: {
    getActionButtons: function() {
      let buttons = [];

      buttons.push({
        action: "create-new"
      });

      return buttons;
    }
  },

  watch: {
    $route: {
      handler: function() {
        this.getKolonneItems();
      },
      deep: true
    }
  },

  methods: {
    getKolonneItems: function() {
      this.isLoading = true;

      let promise = this.$api.clearParams().get("kolonne");

      promise
        .then(response => {
          this.tableItems = response.data.data;
        })
        .catch(error => {
          window.app.$helpers.logger(error);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    onClickActionButton: function(action) {
      switch (action) {
        case "create-new":
          this.onOpenCreateUpdateDialog();
          break;
      }
    },

    onOpenCreateUpdateDialog: function(rowId, rowNumber) {
      this.createUpdateDialogTitle = this.$t("kolonne.create.title");
      if (rowId) {
        this.createUpdateDialogTitle = this.$t("kolonne.update.title");
      }
      this.showCreateUpdateDialog = true;
      this.object.id = rowId;
      this.object.number = rowNumber;
    },

    onCloseCreateUpdateDialog: function() {
      this.showCreateUpdateDialog = false;
      this.object.id = 0;
      this.object.number = "";
    },

    onSaveKolonne: function() {
      let action = "kolonne";
      if (this.object.id) {
        action = "kolonne/" + this.object.id;
      }
      let promise = this.$api.clearParams().post(action, this.object);

      promise
        .then(() => {
          this.onCloseCreateUpdateDialog();
          this.getKolonneItems();
          this.objectSuccess = this.$t("kolonne.create.success");
        })
        .catch(error => {
          this.objectError = this.$t(error.response.data.message);
        });
    },

    onClickSuccessDialogAction: function() {
      this.objectSuccess = null;
    },

    onOpenDeleteDialog: function(rowId, rowNumber) {
      this.deleteKolonneId = rowId;
      this.removeConfirm =
        this.$t("kolonne.message.delete") +
        "<p class='text-center'><strong>" +
        rowNumber +
        "</strong></p>";
    },

    onClickDeleteDialogAction: function(id, action) {
      this.kolonneError = null;
      this.removeConfirm = null;
      switch (action) {
        case "yes":
          this.onDeleteKolonne();
          break;
      }
    },

    onDeleteKolonne: function() {
      this.kolonneError = null;
      this.removeConfirm = null;

      let promise = this.$api
        .clearParams()
        .post("kolonne/" + this.deleteKolonneId + "/delete");

      promise
        .then(() => {
          this.deleteKolonneId = null;
          this.getKolonneItems();
        })
        .catch(error => {
          this.kolonneError = this.$t(error.response.data.message);
        });
    },

    onReorderKolonneTableItems: function() {
      this.tableLoading = true;

      let promise = this.$api
        .clearParams()
        .post("kolonne/reorder", { items: this.tableItems });

      promise
        .then(() => {
          this.tableLoading = false;
          this.getKolonneItems();
        })
        .catch(error => {
          //
        });
    }
  }
};
</script>